import { FunctionComponent } from "react";
import { ReactComponent as RightArrow } from '../../../../../assets/landing-arrow-right.svg';


interface ContentSectionProps {
  title: string;
  subtitle: string;
  description: string;
  linkText: string;
  linkUrl: string;
  imageSrc: string;
  imageAlt: string;
  imagePosition: 'left' | 'right';
}


const ContentSection: FunctionComponent<ContentSectionProps> = ({
  title,
  subtitle,
  description,
  linkText,
  linkUrl,
  imageSrc,
  imageAlt,
  imagePosition
}) => (
  <div className={`flex flex-col ${imagePosition === 'right' ? 'lg:flex-row-reverse' : 'lg:flex-row'} justify-between ${imagePosition === 'right' ? 'mt-14' : 'items-center'}`}>
    <ContentImage src={imageSrc} alt={imageAlt} />
    <ContentText 
      title={title}
      subtitle={subtitle}
      description={description}
      linkText={linkText}
      linkUrl={linkUrl}
    />
  </div>
);


const ContentImage: FunctionComponent<{ src: string; alt: string }> = ({ src, alt }) => (
  <div className="lg:w-[45%]">
    <img
      src={src}
      height={460}
      className="sm:w-full lg:w-[610px]"
      alt={alt}
    />
  </div>
);


const ContentText: FunctionComponent<{
  title: string;
  subtitle: string;
  description: string;
  linkText: string;
  linkUrl: string;
}> = ({ title, subtitle, description, linkText, linkUrl }) => (
  <div className="lg:w-[45%] sm:mt-8 lg:mt-0">
    <ContentTitle title={title} />
    <ContentSubtitle subtitle={subtitle} />
    <ContentDescription description={description} />
    <ContentLink text={linkText} url={linkUrl} />
  </div>
);


const ContentTitle: FunctionComponent<{ title: string }> = ({ title }) => (
  <h3 className="text-xl md:text-6xl text-center lg:text-left lg:text-4xl tracking-wider font-sans font-semibold lg:border-b-2 lg:border-secondary w-fit pr-2 pb-2 pl-12 sm:my-4 lg:mb-8 lg:mt-0">
    {title}
  </h3>
);


const ContentSubtitle: FunctionComponent<{ subtitle: string }> = ({ subtitle }) => (
  <h4 className="text-primary text-xl font-medium pl-12 mb-4">
    {subtitle}
  </h4>
);


const ContentDescription: FunctionComponent<{ description: string }> = ({ description }) => (
  <div className="pl-12 mb-4" dangerouslySetInnerHTML={{ __html: description }} />
);


const ContentLink: FunctionComponent<{ text: string; url: string }> = ({ text, url }) => (
  <a href={url} className="flex items-center">
    <p className="text-secondary pl-12">
      {text}
    </p>
    <RightArrow height={20} width={30} className="mt-0.5 ml-4" />
  </a>
);


export default ContentSection;


